<div *ngIf="data" class="row mb-3">
  <div class="col-md-6">
    <div class="row mt-3">
      <div class="col-md-6"><label>Premium excl IPT:</label></div>
      <div class="col-md-6">
        <div class="input-group">
          <div class="input-group-prepend" *ngIf="!showPremiumAsTbc">
            <span class="input-group-text bg-success text-white">£</span>
          </div>
          <input type="text" [value]="showPremiumAsTbc ? 'TBC' : (policyPremium | premiumPenceUp | number:'1.2-2')" class="form-control form-control-sm" readonly>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6"><label>IPT:</label></div>
      <div class="col-md-6">
        <div class="input-group">
          <div class="input-group-prepend" *ngIf="!showPremiumAsTbc">
            <span class="input-group-text bg-success text-white">£</span>
          </div>
          <input type="text" [value]="showPremiumAsTbc ? 'TBC' : (ipt | premiumPenceUp | number:'1.2-2')" class="form-control form-control-sm" readonly>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6"><label>Premium incl IPT:</label></div>
      <div class="col-md-6">
        <div class="input-group">
          <div class="input-group-prepend" *ngIf="!showPremiumAsTbc">
            <span class="input-group-text bg-success text-white">£</span>
          </div>
          <input type="text" [value]="showPremiumAsTbc ? 'TBC' : (totalPremiumInclIpt | premiumPenceUp | number:'1.2-2')" class="form-control form-control-sm" readonly>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6"><label>UW Fee:</label></div>
      <div class="col-md-6">
        <div class="input-group">
          <div class="input-group-prepend" *ngIf="!showPremiumAsTbc">
            <span class="input-group-text bg-success text-white">£</span>
          </div>
          <input type="text" [value]="showPremiumAsTbc ? 'TBC' : (uwFee | premiumPenceUp | number:'1.2-2')" class="form-control form-control-sm" readonly>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6"><label><strong>Total Amount Payable:</strong></label></div>
      <div class="col-md-6">
        <div class="input-group">
          <div class="input-group-prepend" *ngIf="!showPremiumAsTbc">
            <span class="input-group-text bg-success text-white">£</span>
          </div>
          <input type="text" [value]="showPremiumAsTbc ? 'TBC' : (totalAmountPayable | premiumPenceUp | number:'1.2-2')" class="form-control form-control-sm font-weight-bold" readonly>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row mt-4 align-items-start" *ngIf="quoteDetails?.id && !isBroker">
  <div class="col-lg-7">
    <form novalidate (ngSubmit)="onSaveAdjustments()">
      <h4><u>Premium Adjustments</u></h4>
      <div class="row mb-3">
        <div class="col-md-6"><label>Premium Loading %</label></div>
        <div class="col-md-6">
          <div class="input-group input-group-sm">
            <div class="input-group-prepend">
              <span class="input-group-text bg-success text-white">%</span>
            </div>
            <input type="number" name="premium_loading_percent" class="form-control" [(ngModel)]="adjustments.premium_loading_percent" (ngModelChange)="onAdjustmentsChange()">
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6"><label>Premium Loading Fixed</label></div>
        <div class="col-md-6">
          <div class="input-group input-group-sm">
            <div class="input-group-prepend">
              <span class="input-group-text bg-success text-white">£</span>
            </div>
            <input type="number" name="premium_loading_fixed" class="form-control" [(ngModel)]="adjustments.premium_loading_fixed" (ngModelChange)="onAdjustmentsChange()">
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6"><label>Premium Loading Reason</label></div>
        <div class="col-md-6">
          <input
            type="text"
            name="premium_loading_reason"
            class="form-control form-control-sm"
            [(ngModel)]="adjustments.premium_loading_reason"
            (ngModelChange)="onAdjustmentsChange()"
            placeholder="Enter reason for premium loading"
          >
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6"><label>Premium Discount %</label></div>
        <div class="col-md-6">
          <div class="input-group input-group-sm">
            <div class="input-group-prepend">
              <span class="input-group-text bg-success text-white">%</span>
            </div>
            <input type="number" name="premium_discount_percent" class="form-control" [(ngModel)]="adjustments.premium_discount_percent" (ngModelChange)="onAdjustmentsChange()">
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6"><label>Premium Discount Fixed</label></div>
        <div class="col-md-6">
          <div class="input-group input-group-sm">
            <div class="input-group-prepend">
              <span class="input-group-text bg-success text-white">£</span>
            </div>
            <input type="number" name="premium_discount_fixed" class="form-control" [(ngModel)]="adjustments.premium_discount_fixed" (ngModelChange)="onAdjustmentsChange()">
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6"><label>Premium Discount Reason</label></div>
        <div class="col-md-6">
          <input
            type="text"
            name="premium_discount_reason"
            class="form-control form-control-sm"
            [(ngModel)]="adjustments.premium_discount_reason"
            (ngModelChange)="onAdjustmentsChange()"
            placeholder="Enter reason for premium discount"
          >
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6"><label>Overwrite Underwriting Fee</label></div>
        <div class="col-md-6">
          <div class="input-group input-group-sm">
            <div class="input-group-prepend">
              <span class="input-group-text bg-success text-white">£</span>
            </div>
            <input type="number" name="overwrite_underwriting_fee" class="form-control" [(ngModel)]="adjustments.overwrite_underwriting_fee" (ngModelChange)="onAdjustmentsChange()">
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12 text-right">
          <button type="submit" class="btn btn-success btn-sm" [disabled]="adjustmentSaving">
            {{ adjustmentSaving ? 'Saving...' : 'Save' }}
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="col-lg-5 mt-4 mt-lg-0">
    <app-equine-calculations [quoteInfo]="quoteDetails" [adjustedPremiumDetails]="adjustedPremiumDetails"></app-equine-calculations>
  </div>
</div>

<div class="mt-4" *ngIf="quoteDetails?.id && isBroker">
  <app-equine-calculations [quoteInfo]="quoteDetails" [adjustedPremiumDetails]="adjustedPremiumDetails"></app-equine-calculations>
</div>

<p *ngIf="!data" class="text-muted">No financial data available.</p>
